export default __webpack_public_path__ + "static/media/Shin-straps of the Death Master.18448c0b.jpg";